/* eslint-disable import/prefer-default-export */
/* eslint-disable arrow-parens */
/* eslint-disable object-shorthand */
// eslint-disable-next-line import/no-cycle
/* eslint-disable */
import HttpConnector from "../utils/http-connectors";
import errorHandling from "../utils/error-handler";

export const ApiCalls = {
  mixins: [errorHandling],
  azureSignIn: async billpayUserId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/user/signin?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload: {
          BillPayUID: billpayUserId
        }
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  getBillpayUserIdFromUsername: async billpayUserName => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSBILLPAY_BASE_URL}/user/id/${billpayUserName}?code=${process.env.VUE_APP_AZURE_POSBILLPAY_CODE}&clientId=${process.env.VUE_APP_AZURE_POSBILLPAY_CLIENT_ID}`,
        authenticated: false
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchBillPayPatients: async billpayUserId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSBILLPAY_BASE_URL}/guarantor/list/${billpayUserId}?code=${process.env.VUE_APP_AZURE_POSBILLPAY_CODE}&clientId=${process.env.VUE_APP_AZURE_POSBILLPAY_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchTemplates: async (categoryId = 0, practiceId) => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/template/list/${practiceId}/${categoryId}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchIvrTemplates: async (categoryId = 0) => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/systemtemplate/list/3/${categoryId}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchSystemTemplates: async (templateTypeId, templateCategoryId = 0) => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/systemtemplate/list/${templateTypeId}/${templateCategoryId}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchTemplateCategories: async () => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/templatecategories?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchTemplateTypes: async () => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/templatetypes?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchTemplatePlaceholders: async () => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/templateparameters?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  sendMessage: payload => {
    try {
      const response = HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/sms/send?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  getUserInfo: async billpayUserId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSBILLPAY_BASE_URL}/user/info/${billpayUserId}?code=${process.env.VUE_APP_AZURE_POSBILLPAY_CODE}&clientId=${process.env.VUE_APP_AZURE_POSBILLPAY_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  createTemplate: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/template/create?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  editTemplate: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/template/create?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  deleteTemplate: async templateId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/template/delete/${templateId}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  getSmsCount: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/smscount?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload: payload,
        authenticated: true
      });
      return response;
    } catch (error) {
      console.log("api error: ", error);
      throw error;
    }
  },
  getMmsCount: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/mmscount?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload: payload,
        authenticated: true
      });
      return response;
    } catch (error) {
      console.log("api error: ", error);
      throw error;
    }
  },
  getSmsDetails: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/smscountdetails?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload: payload,
        authenticated: true
      });
      return response;
    } catch (error) {
      console.log("api error: ", error);
      throw error;
    }
  },
  fetchGroups: async practiceId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/groups/practice/${practiceId}/list?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchSenders: async practiceId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/senders/${practiceId}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  addPatientsToGroup: async (patients, groupId) => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/groups/${groupId}/add?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload: patients
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  createGroup: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/groups/create?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  updateGroup: async (groupId, payload) => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "put",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/groups/update/${groupId}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  deleteGroup: async groupId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "delete",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/groups/delete/${groupId}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  getGroupDetails: async groupId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/groups/${groupId}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  getGroupPatients: async groupId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/group/${groupId}/contacts?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  getStaticGroupPatients: async groupId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/staticgroup/${groupId}/patients?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  removePatientFromGroup: async (groupId, patientId) => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/groups/${groupId}/remove/${patientId}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  sanitizePhoneNumbers: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/validatenumber?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  sendEmail: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/email/send?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchDynamicGroups: async practiceId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/dynamicdatagroups/practice/${practiceId}/list?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchDynamicGroupFilters: async () => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/groupfilters?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  createDynamicGroup: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/dynamicgroups/create?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  updateDynamicGroup: async (groupId, payload) => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "put",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/dynamicgroups/update/${groupId}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchDynamicGroupPatients: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/patient/fliterlist?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchDynamicGroup: async groupId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/dynamicgroups/${groupId}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  createSchedule: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/schedule?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  scheduleMessage: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/schedule?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchSchedules: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/schedule/list?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchScheduledMessages: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/schedule/sms/list?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  deleteScheduledMessage: async messageId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "delete",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/schedule/sms/delete/${messageId}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchEhrPatients: async practiceId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/patients/${practiceId}/list?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  createPosPatient: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/contacts?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  editPosPatient: async (payload, patientId) => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "put",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/contacts/${patientId}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  deletePosPatient: async patientId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "delete",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/contacts/${patientId}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        authenticated: true
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  csvImportPosPatient: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/contacts/import?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  uploadMedia: async formData => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/mms-media?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload: formData,
        additionalHeaders: {
          "Content-Type": "multipart/form-data"
        }
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  sendGroupBulkMessage: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/sms/masssend?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  sendGroupBulkEmail: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/email/masssend?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchSurveys: async () => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `https://dt-sms-api.azurewebsites.net/api/surveys?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchSurveyScores: async surveyId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `https://dt-sms-api.azurewebsites.net/api/surveyscores/${surveyId}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchSurveyInsights: async surveyId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `https://dt-sms-api.azurewebsites.net/api/surveyinsights/${surveyId}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchSurveySentenceInsights: async id => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `https://dt-sms-api.azurewebsites.net/api/surveysentenceinsights/${id}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  postFeedback: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/email/feedback?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  executeFlow: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/executeflow?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  getPractices: async () => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/practices?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  getEligibleClinics: async () => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/practices?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  addClinic: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/practice/add?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  getSystemTemplates: async catId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/systemtemplate/list/${catId}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  initiateCall: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/executeflow?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchPracticeFromEmailAddress: async practiceId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/practice/${practiceId}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);
      throw error;
    }
  },
  getContactInfo: async () => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/patient?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  getContactHistory: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/contacthistory?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  getContactGroup: async () => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/patient/groups?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  getReviews: async contactId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/reviews/${contactId}/list?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  getAppointments: async () => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/appts/1/list?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  getPastDueInvoices: async () => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/invoice/patient/list?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  updateContact: async (contactId, payload) => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "put",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/contacts/${contactId}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchDashboardData: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/dashboard/practice/list?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  updateScheduledMessage: async (scheduledMessageId, payload) => {
    try {
      // {{base-url}}/sms/schedule/update/{id}?code={{code}}&clientId={{clientId}}
      const response = await HttpConnector.makeRequest({
        methodType: "put",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/sms/schedule/update/${scheduledMessageId}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchSystemDynamicGroups: async () => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/dynamicdatagroups/system/list?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchFacilities: async () => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/facilities?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  getProvisionTwilioNumber: async () => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/provisiontwilionumber?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  getMessagingServices: async () => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/messagingservices?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchPatientNotes: async patientId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/patient/notes/${patientId}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  addPatientNote: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/patient/note?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  deletePatientNote: async noteId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "delete",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/patient/note/delete/${noteId}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  getCommPreferences: async contactId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/patient/${contactId}/comperflist?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  getPDCommPreferences: async contactId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/patient/${contactId}/pdcomperflist?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  setCommPreferences: async (payload, contactId) => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/patient/${contactId}/comperf?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  setPDCommPreferences: async (payload, contactId) => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/patient/${contactId}/pdcomperf?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  getAllCommPreferenceTypes: async () => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/perferencetypes?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  resetClinic: async practiceId => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "delete",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/practice/reset/${practiceId}?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  fetchUserName: async () => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "get",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/user?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  syncPatientAccount: async (payload, patientId) => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/sync/patient/${patientId}/account?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  syncGuarantorAccount: async (payload, guarantorId) => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/sync/guarantor/${guarantorId}/account?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  },
  updatePatientGuarantorData: async payload => {
    try {
      const response = await HttpConnector.makeRequest({
        methodType: "post",
        url: `${process.env.VUE_APP_AZURE_POSCOM_BASE_URL}/patient/guarantor/update?code=${process.env.VUE_APP_AZURE_POSCOM_CODE}&clientId=${process.env.VUE_APP_AZURE_POSCOM_CLIENT_ID}`,
        payload
      });
      return response;
    } catch (error) {
      this.logErrorsAndExceptions('ErrorException', error.message);

      throw error;
    }
  }
};
